// extracted by mini-css-extract-plugin
export default {"popupPremiumAnswerUsed":"PopupPremiumAnswerUsed_popupPremiumAnswerUsed__+oMwa","button":"PopupPremiumAnswerUsed_button__K9mI1"};